import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import keyValueReducer from '@chronos/ui-toolkit/reducers/keyValueReducer';
import { setState } from '@chronos/ui-toolkit/actions';
import Popup from '../Popup';
import * as S from './styled';

const CommentPopover = ({ onSubmit, comment, icon }) => {
  const [state, dispatch] = useReducer(keyValueReducer, {
    isCommentPopupVisible: false,
    worklogComment: comment || '',
  });

  useEffect(() => {
    dispatch(
      setState({
        worklogComment: comment,
      })
    );
  }, [comment]);

  return (
    <Popup
      handleOuterAction={() => {
        dispatch(
          setState({
            isCommentPopupVisible: false,
          })
        );
        onSubmit(state.worklogComment);
      }}
      isOpen={state.isCommentPopupVisible}
      setPopupVisible={() => {
        dispatch(
          setState({
            isCommentPopupVisible: !state.isCommentPopupVisible,
          })
        );
      }}
      trigger={
        <S.CommentIcon>{icon || <S.AddworklogCommentIcon />}</S.CommentIcon>
      }
    >
      <S.WorklogCommentForm>
        <S.Textarea
          autoFocus
          minRows={4}
          maxRows={10}
          placeholder="Work log comment"
          style={{ width: '100%' }}
          value={state.worklogComment || ''}
          onChange={(ev) => {
            dispatch(
              setState({
                worklogComment: ev.target.value,
              })
            );
          }}
        />
      </S.WorklogCommentForm>
    </Popup>
  );
};

CommentPopover.defaultProps = {
  comment: '',
};

CommentPopover.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  comment: PropTypes.string,
};

export default CommentPopover;
